// extracted by mini-css-extract-plugin
export var root = "d0a19b97838279642cc66af9c943625c-css";